import { FascicoloFull } from '../../../../common/models/fascicolo/fascicolo-full';
import { TipoTipologica } from '../../../../common/models/tipologiche/tipo-tipologica';

export class FascicoloRicorsoAmministrativo extends FascicoloFull {
  constructor() {
    super();
    this.dataInizioFascicolo = + new Date();
  }

  //integrato: boolean;
  //dataIntegrazione: number;
  esitoDelibera: string;
  numeroDelibera: string;
  dataDelibera: number;
  esitoDefinitivo: boolean;
  numeroGiuntaEsecutiva: string;
  dataGiuntaEsecutiva: number;
  oggettoRicorso: TipoTipologica;
  organoCompetente: TipoTipologica;
  dataProvvedimento: number;
  numeroProvvedimento: string;
}
